import * as React from "react";
const SvgCheckCircleLightOutline = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 57 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.5.5C13.054.5.5 13.054.5 28.5s12.554 28 28 28 28-12.554 28-28-12.554-28-28-28zm0 3c13.825 0 25 11.175 25 25s-11.175 25-25 25-25-11.175-25-25 11.175-25 25-25z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.281 16.387 22.236 37.432l-8.517-8.52-2.121 2.123 10.638 10.639 23.166-23.166Z",
  fill: "currentColor"
}));
export default SvgCheckCircleLightOutline;